/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".study-bundle[_ngcontent-%COMP%]{margin-bottom:25px;min-height:0;opacity:1;padding-bottom:4rem}.anchor[_ngcontent-%COMP%]{scroll-margin-top:4rem!important}"];
export { styles as styles };
//# sourceMappingURL=study-bundle.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/study-bundle/study-bundle.component.scss.shim.ngstyle.js
// module id = 1472
// module chunks = 27 28 29